import { useCallback } from 'react';
import Button from 'components/Button';
import styles from './styles/PhotoGalleryAlertModal.module.scss';
import { usePhotoGalleryContainer } from '..';

export default function PhotoGalleryCopyrightNotice() {
  const [{}, { setAlertType, acceptCopyrightAgreement }] = usePhotoGalleryContainer();

  const handleAccept = useCallback(() => {
    setAlertType(null);
    acceptCopyrightAgreement(window.location.origin);
  }, [acceptCopyrightAgreement, setAlertType]);

  const handleReject = useCallback(() => {
    window.history.back();
  }, []);

  return (
    <>
      <div className={styles.ModalHeading}>Copyright Agreement</div>
      <div className={styles.ModalBody}>
        The photos in this album are the copyright of the professional photographer that took them. Copying or taking a screenshot of any
        photo is a violation of the copyright agreement and copyright laws. High-quality digital downloads of each photo are available for
        purchase in most cases.
      </div>
      <div className={styles.CopyrightButtons}>
        <Button label="Cancel" type="v2" className={styles.ModalCancelButton} onClick={handleReject} />
        <Button label="Accept" type="v2" className={styles.ModalAcceptButton} onClick={handleAccept} />
      </div>
    </>
  );
}
